// Firebase web SDK init. Config comes from VITE_FIREBASE_* env (public,
// allow-listed by project — same values as ui/). Uses browserLocalPersistence
// so sessions survive reloads.
import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, setPersistence, browserLocalPersistence, inMemoryPersistence } from 'firebase/auth';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence).catch((e) => {
  console.warn('[firebase] setPersistence failed:', e?.message || e);
});

export { app };

/**
 * design/027 — a separate, in-memory Firebase auth used only to prove
 * ownership of an existing account when linking (e.g. a Sign in with Apple
 * "Hide My Email" login). Signing in here never replaces the main session.
 */
let linkApp = null;
export async function linkingAuth() {
  if (!linkApp) {
    linkApp = getApps().find((a) => a.name === 'link') || initializeApp(firebaseConfig, 'link');
  }
  const a = getAuth(linkApp);
  await setPersistence(a, inMemoryPersistence).catch(() => {});
  return a;
}
